<div class="dialog">
  <div class="dialog__header">
    <h1 class="dialog__title">{{ title }}</h1>
    <span class="close" (click)="close()"></span>
  </div>
  <div class="dialog__body">
    <div class="job-grad-pattern-add-dialog__group">
      <div class="job-grad-pattern-add-dialog__group-label" *ngIf="conditionKey === 'other' && hasFixedOvertimeFee">固定深夜割増</div>
      <div class="job-grad-pattern-add-dialog__group-rows" *ngIf="conditionKey === 'salary' || hasFixedOvertimeFee">
        <div class="job-grad-pattern-add-dialog__row">
          <div class="job-grad-pattern-add-dialog__label job-grad-pattern-add-dialog__label--sub">金額</div>
          <div class="job-grad-pattern-add-dialog__field job-grad-pattern-add-dialog__field--unit">
            <input
              type="number"
              class="job-grad-pattern-add-dialog__input"
              [(ngModel)]="conditions.amount"
            />
            <span class="job-grad-pattern-add-dialog__unit">円</span>
          </div>
        </div>
        <div class="job-grad-pattern-add-dialog__row" *ngIf="conditionKey === 'fixedOvertime' || conditionKey === 'fixedLateNightOvertime' || conditionKey === 'other'">
          <div class="job-grad-pattern-add-dialog__label job-grad-pattern-add-dialog__label--sub">時間</div>
          <div class="job-grad-pattern-add-dialog__field job-grad-pattern-add-dialog__field--unit">
            <input
              type="number"
              class="job-grad-pattern-add-dialog__input"
              [(ngModel)]="conditions.hours"
            />
            <span class="job-grad-pattern-add-dialog__unit">時間</span>
          </div>
        </div>
        <div class="job-grad-pattern-add-dialog__row">
          <div class="job-grad-pattern-add-dialog__label job-grad-pattern-add-dialog__label--sub">種別</div>
          <ag-select
            #gradCategorySelect
            class="job-grad-pattern-add-dialog__field"
            [options]="gradCategoryOptions"
            valueField="gradCategory"
            labelField="label"
            [placeholder]="'選択してください'"
            [multi]="true"
            [(ngModel)]="conditions.gradCategories"
            [extraClass]="'select-btn--no-dim'"
          ></ag-select>
        </div>
      </div>
    </div>
    <div class="job-grad-pattern-add-dialog__conditions" *ngIf="conditionKey === 'other'">
      <div class="job-grad-pattern-add-dialog__row">
        <div class="job-grad-pattern-add-dialog__label">月間所定労働時間</div>
        <div class="job-grad-pattern-add-dialog__field job-grad-pattern-add-dialog__field--unit">
          <input
            type="number"
            class="job-grad-pattern-add-dialog__input"
            [(ngModel)]="conditions.monthlyScheduledWorkingHours"
          />
          <span class="job-grad-pattern-add-dialog__unit">時間</span>
        </div>
      </div>
      <div class="job-grad-pattern-add-dialog__row">
        <div class="job-grad-pattern-add-dialog__label">年間所定労働時間</div>
        <div class="job-grad-pattern-add-dialog__field job-grad-pattern-add-dialog__field--unit">
          <input
            type="number"
            class="job-grad-pattern-add-dialog__input"
            [(ngModel)]="conditions.annualScheduledWorkingHours"
          />
          <span class="job-grad-pattern-add-dialog__unit">時間</span>
        </div>
      </div>
      <div class="job-grad-pattern-add-dialog__row">
        <div class="job-grad-pattern-add-dialog__label">変形労働時間制</div>
        <div class="job-grad-pattern-add-dialog__radio-group">
          <label
            class="job-grad-pattern-add-dialog__radio-item"
            *ngFor="let option of variableWorkingHoursSystemOptions"
          >
            <input
              type="radio"
              name="variableWorkingHoursSystem"
              [value]="option"
              [checked]="conditions.variableWorkingHoursSystem === option"
              (change)="onVariableWorkingHoursSystemChange(option)"
            />
            <span>{{ option }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="dialog__footer">
    <button class="dialog__button dialog__button--accent" (click)="close()">
      キャンセル
    </button>
    <button
      class="dialog__button dialog__button--primary"
      (click)="add()"
      [disabled]="isAddDisabled"
    >
      追加
    </button>
  </div>
</div>
